import { zodResolver } from '@hookform/resolvers/zod';
import { LoginInputSchema, type LoginInput } from '@booknest/shared';
import { useForm } from 'react-hook-form';

import { Button } from '@/shared/components/Button.js';
import { Input } from '@/shared/components/Input.js';

import { useLogin } from '../hooks/useLogin.js';

interface LoginFormProps {
  onSuccess?: () => void;
}

export function LoginForm({ onSuccess }: LoginFormProps): JSX.Element {
  const { register, handleSubmit, formState } = useForm<LoginInput>({
    resolver: zodResolver(LoginInputSchema),
  });
  const login = useLogin();

  const onSubmit = handleSubmit(async (data) => {
    await login.mutateAsync(data);
    onSuccess?.();
  });

  return (
    <form onSubmit={onSubmit} className="flex flex-col gap-4">
      <Input
        id="email"
        type="email"
        label="Email"
        autoComplete="email"
        {...register('email')}
        error={formState.errors.email?.message}
      />
      <Input
        id="password"
        type="password"
        label="Mot de passe"
        autoComplete="current-password"
        {...register('password')}
        error={formState.errors.password?.message}
      />
      {login.isError && (
        <p className="text-sm text-red-600">Identifiants incorrects.</p>
      )}
      <Button type="submit" fullWidth disabled={login.isPending}>
        {login.isPending ? 'Connexion…' : 'Se connecter'}
      </Button>
    </form>
  );
}
